import { useQuery } from '@tanstack/react-query'

import { api } from '../../../services/api'
import {
  CitiesRequestFilters,
  CityData,
  PaginatedData,
} from '../../../types/interfaces'
import { queriesKeys } from '../queriesKeys'

type UseGetCities<T> = {
  enabled?: boolean
  filters?: CitiesRequestFilters
  noAuth?: boolean
  select?: (data: PaginatedData<CityData[]>) => T
}

export const useGetCities = <T>({
  enabled,
  filters,
  noAuth,
  select,
}: UseGetCities<T>) =>
  useQuery({
    enabled,
    queryFn: () => api.cities.getCities(filters, { noAuth }),
    queryKey: queriesKeys.cities.getCities(filters, noAuth),
    refetchOnWindowFocus: false,
    select,
  })
